class PandaApi {
    baseUrl = 'https://storefront-api.panda-weltmaschine.de/';;

    notifyAboutFallbackImage(productId) {
        const path = this.baseUrl + 'fallback-image/notify';
        fetch(path, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ productId })
        });
    }
}